import { getDashboardData } from "../../../shared/api/ui";
import { useQuery } from "@tanstack/react-query";
import type { DashboardData } from "../../../shared/types/dashboard-data.type";

const fetchDashboardData = async (): Promise<DashboardData> => {
	const response = await getDashboardData();
	if (!response.success || response.data == null) {
		throw new Error(response.message ?? "Dashboard data request failed");
	}

	return response.data;
};

export const useDashboardData = () => {
	const query = useQuery({
		queryKey: ["dashboard-data"],
		queryFn: fetchDashboardData,
		staleTime: 1000 * 30,
		refetchInterval: 30 * 1000,
		refetchOnWindowFocus: true,
		retry: 3,
		retryDelay: (attemptIndex) =>
			Math.min(1000 * 2 ** attemptIndex, 10_000),
	});

	const isAwaitingDashboardContent =
		!query.data &&
		(query.isPending || query.isFetching || query.isError);

	return { ...query, isAwaitingDashboardContent };
};
